module.exports = angular.module('cartographer.common.log', [])

_ = require 'underscore'

module.exports.factory 'crtLog', $DI ($log, crtConfig) ->

  mode  = crtConfig.log.mode
  level = crtConfig.log.level

  _stringifyArray = (arr) ->
    ans = ""
    for item in arr
      try
        ans += JSON.stringify(item, null, 2) + "\n"
      catch e
        ans += "<cyclic>\n"
    ans

  error = ->
    try
      if level > 0
        switch mode
          when 'array' then $log.error(Array.prototype.slice.call(arguments))
          when 'json'  then $log.error(_stringifyArray(Array.prototype.slice.call(arguments), null, 2))
          else              $log.error.apply(this, arguments)
    catch exn
      $log.error('crtLog.error', 'exception thrown while logging')

  warn = ->
    try
      if level > 1
        switch mode
          when 'array' then $log.warn(Array.prototype.slice.call(arguments))
          when 'json'  then $log.warn(_stringifyArray(Array.prototype.slice.call(arguments), null, 2))
          else              $log.warn.apply(this, arguments)
    catch exn
      error('crtLog.warn: attempt to log cyclic structure')

  info = ->
    try
      if level > 2
        switch mode
          when 'array' then $log.info(Array.prototype.slice.call(arguments))
          when 'json'  then $log.info(_stringifyArray(Array.prototype.slice.call(arguments), null, 2))
          else              $log.info.apply(this, arguments)
    catch exn
      error('crtLog.info: attempt to log cyclic structure')

  debug = ->
    try
      if level > 3
        switch mode
          when 'array' then $log.debug(Array.prototype.slice.call(arguments))
          when 'json'  then $log.debug(_stringifyArray(Array.prototype.slice.call(arguments), null, 2))
          else              $log.debug.apply(this, arguments)
    catch exn
      error('crtLog.debug: attempt to log cyclic structure')

  debugStack = (args...) ->
    debug(args..., new Error('Stack trace'))

  profileStats = {}

  calcProfileStats = (message, time) ->
    profileStats[message] ?= { count: 0, total: 0, average: 0, last: 0 }
    stats = profileStats[message]
    stats.count = stats.count + 1
    stats.total = stats.total + time
    stats.average = stats.total / stats.count
    stats.last = time
    stats

  profile = (message, func) ->
    if level > 3
      debug("PROFILE #{message} >>")
      t0 = new Date().getTime()
      ans = func()
      t1 = new Date().getTime()
      stats = calcProfileStats(message, t1 - t0)
      debug("PROFILE #{message} <<", stats)
      ans
    else
      func()

  return {
    error
    warn
    info
    debug
    profile
    debugStack
  }
